import styles from './seventh.module.css';
import Header from '../../components/header';
import FullSize from '../../components/full-size';
import AnswerForm from '../../components/answer-form';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { isLevelAllowed } from '../../helper';
import HintBox from '../../components/hint-box';

function Seventh() {
  const LEVEL = 7;
  const navigate = useNavigate();
  const [shake, setShake] = useState(false);

  useEffect(() => {
    if (!isLevelAllowed(LEVEL)) {
      navigate('/cheating');
    }
  }, [navigate]);

  const handleSubmit = (answer: string) => {
    // Alltid fel svar - skaka alltid
    setShake(true);
  };

  return (
    <FullSize bgColor='transparent'>
      <div className={styles.seventh_wrapper}>
        <Header level={7} />
        <AnswerForm 
          type="number" 
          onSubmit={handleSubmit} 
          shake={shake} 
          setShake={setShake}
        />
      </div>
      <HintBox hintText="De tre första brickorna visar +46..." />
    </FullSize>
  );
}

export default Seventh;
